import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import Select from 'react-select';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class InstanceFilter extends Component {
    state = {
         instanceLists: [{value: '', label: 'All'}],
         instanceValue:'',
    };
    componentDidMount(){
        this._getinstance();
    }

    resetinstanceFilter(){
        this.setState({
        instanceValue: [],
        })
    }
     _getinstance(){
        axios.get(config.get('API_URL')+'/filters/get_instance/',

                {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {

            let instanceLists = [{value: '', label: 'All'}];

            response.data.map((ev,index) => {
                instanceLists.push({value: ev.instance_id, label: ev.instance_abrv})
            });
            this.setState({
                instanceLists:instanceLists,
            })
        });
    }
    changeinstance(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;
        this.props.onSelectinstance(optionSelected);
        this.setState({
            instanceValue:optionSelected,
        });

    }

    render() {
        return (
            <Select name="instance"
            value={this.state.instanceValue}
            styles={reactSelectStyles} className="report-listbox"
            isClearable={false}
            onChange={this.changeinstance.bind(this)}
            options={this.state.instanceLists}
            placeholder="Select [instance]"
        />
        );
    }
}
export default InstanceFilter;